import { HUB_LOGO_HEIGHT, HUB_LOGO_HEIGHT_LEGACY } from '../constants';

/**
 * Returns the appropriate logo height based on hub type.
 *
 * @param hubType - The type of hub (HELP_HUB, CUSTOMER_SERVICE, etc.)
 * @returns The logo height as a CSS string ('32px' or '40px')
 *
 * Logic:
 * - HELP_HUB: Always returns 32px (new standard)
 * - CUSTOMER_SERVICE: Always returns 32px
 * - Other hub types: Returns 40px (legacy fallback)
 */
export const getHubLogoHeight = (hubType: string | null | undefined): string => {
	// Help hubs always use new height
	if (hubType === 'HELP_HUB') {
		return HUB_LOGO_HEIGHT;
	}
	// CSM hubs always use new height
	if (hubType === 'CUSTOMER_SERVICE') {
		return HUB_LOGO_HEIGHT;
	}
	// Fallback to legacy height for other hub types
	return HUB_LOGO_HEIGHT_LEGACY;
};
